import { ActionIcon, Checkbox, Group, Paper, Tooltip } from "@mantine/core";
import { FaInfoCircle } from "react-icons/fa";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  selectStandardRoomShowFurniture,
  selectStandardRoomShowLengthComponents,
  selectStandardRoomShowOnlyCeilingComponents,
  setStandardRoomShowFurniture,
  setStandardRoomShowLengthComponents,
  setStandardRoomShowOnlyCeilingComponents,
} from "./standardRoomSlice";

const StandardRoomViewerFilters = () => {
  const dispatch = useAppDispatch();

  const showOnlyCeilingComponents = useAppSelector(selectStandardRoomShowOnlyCeilingComponents);
  const showLengthComponents = useAppSelector(selectStandardRoomShowLengthComponents);
  const showFurniture = useAppSelector(selectStandardRoomShowFurniture);

  return (
    <Paper
      px="sm"
      py={6}
      bg="gray.0"
      withBorder
      radius={0}
      style={{ borderLeft: 0, borderRight: 0, borderTop: 0 }}
    >
      <Group gap="md">
        <Group gap={4} wrap="nowrap">
          <Group gap={4} wrap="nowrap">
            <Checkbox
              label="Kun i himling"
              checked={showOnlyCeilingComponents}
              onChange={(event) =>
                dispatch(setStandardRoomShowOnlyCeilingComponents(event.currentTarget.checked))
              }
            />
            <Tooltip
              label="Viser komponenter som Multiplacer har klassifisert som himlingskomponenter. Det kan også finnes andre objekter i himlingen som ikke er en del av denne klassifiseringen."
              multiline
              maw={320}
              withArrow
            >
              <ActionIcon
                variant="subtle"
                color="gray"
                size="sm"
                aria-label="Info om himlingsfilter"
          >
                <FaInfoCircle size={14} />
              </ActionIcon>
            </Tooltip>
          </Group>
        </Group>
        {!showOnlyCeilingComponents && (
          <>
            <Checkbox
              label="Vis møbler"
              checked={showFurniture}
              onChange={(event) =>
                dispatch(setStandardRoomShowFurniture(event.currentTarget.checked))
              }
            />
            <Checkbox
              label="Vis lengdekomponenter"
              checked={showLengthComponents}
              onChange={(event) =>
                dispatch(setStandardRoomShowLengthComponents(event.currentTarget.checked))
              }
            />
          </>
        )}
      </Group>
    </Paper>
  );
};

export default StandardRoomViewerFilters;
